module.exports = __webpack_public_path__ + "img/NX.7e605d1c.png";